export const RESOURCE_TYPE = 'RESOURCE_TYPE_RECOMMENDATIONS_FETCH_SITE_TRAITS';
export const RESOURCE_KEY = 'recommendations-fetch-site-traits-resource-key';
export const ANALYTICS_ID = 'useResource.fetchRecommendationsSiteTraits';
